import { defineAsyncComponent } from 'vue'
import { tabOutlineColumns } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { QueryConfig } from 'src/composables/use-query'
import type {
  FeatureConfig,
  MainFeatureTwin,
  FeatureQueryTwin,
  FeatureParameterConfigs
} from 'src/models'
import type { TableTileConfig } from 'src/components/tiles/TableTile'
import type { QUERY_KIND } from 'src/services/constants'

export interface TableFeatureTwin extends MainFeatureTwin, QueryConfig, TableTileConfig {
  filter?: boolean
  allowExportExcel?: boolean
  queryKind?: QUERY_KIND
  query?: string
  viewerLoadState?: boolean
  viewerIsolateItems?: boolean
  parameters?: FeatureParameterConfigs
  /** Automatically sync selected twins to the store when selection changes */
  syncSelection?: boolean
  /** Always fetch selected twins from API even if already in the store */
  syncSelectionOverwrite?: boolean
}

/** dtmi:com:arcadis:app:TableQuery;2 */
export interface TableQueryTwin extends FeatureQueryTwin, QueryConfig, TableTileConfig {}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./TableFeatureMain.vue')),
    splitter: 900,
    icon: tabOutlineColumns,
    label: 'Table'
  }
}

export default featureConfig
